<template>
  <div>
    <page-title title="Your skills" description="Select you top five (5) skills based on what your experience is" />

    <v-select
      multiple
      v-model="details.skills"
      :disabled="details.skills.length >= 5"
      :options="skillList"
      placeholder="Select up to five skills"
      taggable
      push-tags
      @input="search"
      @option:selected="update"
    >
      <!-- eslint-disable-next-line vue/no-unused-vars  -->
      <template #selected-option-container="item">
        <div class="hidden bg-transparent"></div>
      </template>

      <!-- eslint-disable-next-line vue/no-unused-vars  -->
      <template #no-options="item">
        <div>Type and press enter to add a skill</div>
      </template>
    </v-select>

    <div class="mt-10">
      <div class="grid gap-4 grid-cols-2 items-center mb-6" v-for="(item, i) in details.skills" :key="i">
        <div class="">
          <div class="bg-gray-200 px-6 py-1.5 inline-flex items-center gap-x-3 rounded-xl">
            <p class="text-base">{{ item }}</p>
            <img src="@/assets/icons/times.svg" class="cursor-pointer" @click="remove(i)" alt="" />
          </div>
        </div>

        <div class="flex items-center gap-x-3">
          <vue3-slider
            v-model="selectedMarks[i]"
            :height="6"
            track-color="#ccc"
            :step="1"
            :handleScale="2"
            :alwaysShowHandle="true"
            color="#1a1a1a"
            :max="10"
          />
          <p>{{ selectedMarks[i] || 0 }}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import PageTitle from './PageTitle.vue';
import Vue3Slider from 'vue3-slider';
import { ref } from 'vue';

const props = defineProps({
  skillList: {
    type: Array,
    default: [],
  },
  details: {
    type: Object,
  },
});

const emit = defineEmits(['update', 'search']);
const selectedMarks = ref([]);
const selected = ref([]);

const remove = (index) => {
  props.details.skills.splice(index, 1);
  selectedMarks.value.splice(index, 1);
};

const update = (data) => {
  const newSkills = data.filter((item) => !props.skillList.includes(item) && item.length > 2);

  if (newSkills.length) emit('update', newSkills);
};

const search = ($event) => {
  const timeoutId = window.setTimeout(() => {}, 0);
  for (let id = timeoutId; id >= 0; id -= 1) {
    window.clearTimeout(id);
  }
  setTimeout(() => {
    const value = $event.target.value;
    if (!value) return;
    emit('search', value);
  }, 500);
};
</script>
